export default {
	title: "Clôture du rituel",
	closeRitual: "Clôturer le rituel",
	closingDate: "Date de clôture",
	closingTime: "Heure de clôture",
	closingConfirm: "Confirmer la clôture de ce rituel ? Cette action est irréversible.",
	noTickets: "Aucun ticket enregistré pour ce rituel",
	sections: {
		messages: "Messages",
		return: "Retour",
	},
	addMessage: "Ajouter un message",
	noMessages: "Aucun message ajouté",
	returnType: {
		NEXT_RITUAL: "Prochain rituel",
		SPECIFIC_RITUAL: "Rituel spécifique",
		SPECIFIC_CARD: "Carte spécifique",
	},
	returnFields: {
		returnType: "Type de retour",
		selectRitual: "Sélectionnez le rituel",
		selectAttendanceType: "Type de carte",
		quantity: "Quantité",
		indefinite: "Indéfini",
		notes: "Notes",
	},
	quickClose: {
		confirm: "Confirmer la clôture de ce rituel ? Cette action est irréversible.",
	},
	messages: {
		closed: "Rituel clôturé avec succès",
		closeError: "Erreur lors de la clôture du rituel",
		alreadyClosed: "Ce rituel est déjà clôturé",
	},
	summary: {
		messagesLabel: "messages",
		returnsLabel: "retours",
	},
	pendingReturns: "Retours en attente",
	expandAll: "Tout développer",
	collapseAll: "Tout réduire",
};
